module.exports = __webpack_public_path__ + "img/Edit-pencil.757d1779.svg";